import angular from 'angular';
import template from './fieldset.html';
import fbtemplate from './builder/preview.html';
import FieldsetComponent from './fieldset.component';

const fieldsetConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('fieldset', {
		title: 'Field Set',
		template,
		group: 'layout',
		children:   false,
		selectable: true,
		settings: new FieldsetComponent(),
		fbtemplate,
		icon: 'fa fa-th-large',
		views: [
			{
				name: 'Display',
				template: 'kform/components/fieldset/display.html',
			},
			{
				name: 'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name: 'API',
				template: 'kform/components/common/api.html',
			},
			{
				name: 'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		noDndOverlay: true,
		confirmRemove: true,
	});
};

export default angular.module('app').config(fieldsetConfig);
